import React from "react";
import "./career-lisiting-with-filters.styles.scss";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import CareerListing from "../career-lisiting/career-lisiting.component";

//#RP - Task 124 Career
function ResourceListingWithFilter({cdata}) {
  return (
    <div className="career-outer-container module-spacer-bottom sm-up-module-spacer-top">
        <Row className="no-gutter-around">
            <Col>
              {cdata && 
               <CareerListing 
                 data={cdata.AvailablePositionsContent.IndividualAvailablePositionsContent}
              />}
            </Col>
          </Row>
      {/* //<ContentWithSidebar */}
        {/* //left={ */}
          
        {/* //} */}
        {/* // right={<AdvancedSearch />} */}
      {/* ///> */}
    </div>
  );
}

export default ResourceListingWithFilter;
